module.exports = __webpack_public_path__ + "img/visa.d4e61660.png";